import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

import type { DualPathMutationResult } from '../dualPathMutationResult';

const mapTrpcResponseToGraphQL = (trpcData: { affected_rows: number }) => {
  return {
    delete_internal_audit_entity: {
      __typename: 'internal_audit_entity_mutation_response' as const,
      affected_rows: trpcData.affected_rows,
    },
  };
};

export type DeleteInternalAuditsResult = ReturnType<
  typeof mapTrpcResponseToGraphQL
>;
export type DeleteInternalAuditsCompatibilityResult =
  DualPathMutationResult<DeleteInternalAuditsResult>;

export const useDeleteInternalAuditsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.internalAuditEntity.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.internalAuditEntity.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey:
            trpc.frontend.internalAuditEntity.internalAuditById.queryKey(),
        });
      },
    }),
  });

  return {
    deleteInternalAudits: async (
      ids: string[]
    ): Promise<DeleteInternalAuditsResult> => {
      const result = await mutation.mutateAsync({ Ids: ids });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
